/* ============================================================
   IDEAS CAFE — <ideas-cart>

   Quantity and removal on the cart page. Mutations go to
   /cart/change.js, then the section is re-rendered from the server
   so every money value stays server-formatted — the same discipline
   as the cart rail and the product page.
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('ideas-cart')) return;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  class IdeasCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this._onClick = this._onClick.bind(this);
      this._onCart = this._onCart.bind(this);

      this.addEventListener('click', this._onClick);
      // Another surface (rail, add button) changed the cart — re-render
      // so this page never disagrees with the header count.
      document.addEventListener('ideas:cart:updated', this._onCart);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('ideas:cart:updated', this._onCart);
      if (this._controller) this._controller.abort();
    }

    _onCart(event) {
      // Skip the echo of our own change; _change already re-rendered.
      if (this._selfUpdate) {
        this._selfUpdate = false;
        return;
      }
      if (event.detail && event.detail.cart) this._render();
    }

    _onClick(event) {
      var btn = event.target.closest('[data-qty-change]');
      if (!btn || this.hasAttribute('aria-busy')) return;
      event.preventDefault();
      this._change(btn.dataset.line, btn.dataset.quantity);
    }

    _change(line, quantity) {
      var self = this;
      this.setAttribute('aria-busy', 'true');

      fetch(routeRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'Cart update failed');
            return body;
          });
        })
        .then(function (cart) {
          self._selfUpdate = true;
          if (window.IdeasCart) window.IdeasCart.broadcast(cart);
          return self._render();
        })
        .catch(function (err) {
          console.warn('[ideas] cart change failed', err);
        })
        .then(function () {
          self.removeAttribute('aria-busy');
        });
    }

    _render() {
      if (!this.sectionId) {
        window.location.reload();
        return;
      }

      // A rapid click run would otherwise race several renders; the
      // last request wins and earlier ones are aborted.
      if (this._controller) this._controller.abort();
      this._controller = new AbortController();

      var self = this;
      return fetch(routeRoot() + '?section_id=' + this.sectionId, {
        signal: this._controller.signal
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Section render failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('ideas-cart');
          if (fresh) self.innerHTML = fresh.innerHTML;
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          console.warn('[ideas] cart render failed', err);
        });
    }
  }

  customElements.define('ideas-cart', IdeasCart);
})();
